import PropTypes from 'prop-types';
import TextArea from '../../../../juristec-ui/core/TextArea';

const TextAreaInput = ({
  label, placeholder = '', state, handle, blur = () => {},
}) => (
  <>
    <h5 className={state.error ? 'field-error-label' : ''}>
      {label}
    </h5>
    <TextArea
      value={state.value}
      placeholder={placeholder}
      // errorMessage={state.errorMsg}
      // error={state.errorMsg.length > 0}
      onChange={handle}
      onBlur={blur}
    />
    {state.errorMsg.length > 0 && (
      <span className="field-error-msg">
        {state.errorMsg}
      </span>
    )}
  </>
);

TextAreaInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  state: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
  }).isRequired,
  handle: PropTypes.func.isRequired,
  blur: PropTypes.func,
};

export default TextAreaInput;
